import { atom } from 'jotai';

/**
 * Tracks whether the user should see the affiliate link modal
 * Set to true when user arrives with ?show_referral=true query param
 * Reset after modal is dismissed
 */
export const shouldShowAffiliateLinkModalAtom = atom<boolean>(false);

/**
 * Session flag to track if we've already processed the show_referral URL parameter
 * Prevents re-triggering the modal after user closes it while URL param is still present
 */
export const hasShownAffiliateLinkModalAtom = atom<boolean>(false);
